export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "zonesCategories.worker.cfea3c308208bc3a59b6.worker.js");
}
